module.exports = __webpack_public_path__ + "static_pc/img/ba02.4b125c2e.png";